import { OnboardingStepKey } from '@dsgvo-buddy/types';

export interface OnboardingStepText {
  number: number;
  title: string;
  description: string;
  ctaLabel: string;
  ctaRoute: string;
  icon: string;
  tip?: string;
}

export const ONBOARDING_STEP_TEXTS: Record<OnboardingStepKey, OnboardingStepText> = {
  organization: {
    number: 1,
    title: 'Organisation einrichten',
    description: 'Der Datenschutz beginnt bei der Verantwortlichkeit. Art. 4 Nr. 7 DSGVO definiert den Verantwortlichen als diejenige Stelle, die über Zweck und Mittel der Verarbeitung entscheidet — das sind Sie. Hier hinterlegen Sie Firmendaten, Kontaktperson und ggf. Ihren Datenschutzbeauftragten. Diese Angaben bilden die Grundlage für alle weiteren Dokumente.',
    ctaLabel: 'Organisation bearbeiten',
    ctaRoute: '/organization',
    icon: 'building',
  },
  service_providers: {
    number: 2,
    title: 'Dienstleister erfassen',
    description: 'Jedes Unternehmen arbeitet mit externen Dienstleistern: Cloud-Anbietern, Lohnbüros, E-Mail-Providern. Sobald dort personenbezogene Daten verarbeitet werden, benötigen Sie einen Auftragsverarbeitungsvertrag nach Art. 28 DSGVO. Legen Sie hier alle relevanten Dienstleister an — Sie verknüpfen sie später mit den jeweiligen Verarbeitungen.',
    ctaLabel: 'Dienstleister anlegen',
    ctaRoute: '/service-providers/new',
    icon: 'supplier',
    tip: 'Denken Sie auch an Steuerberater, Buchhaltung, Hosting und Microsoft/Google Workspace.',
  },
  toms: {
    number: 3,
    title: 'Technische & organisatorische Maßnahmen dokumentieren',
    description: 'Art. 32 DSGVO verpflichtet Sie, geeignete Schutzmaßnahmen nachzuweisen — von Zugriffskontrollen über Verschlüsselung bis zu Backup-Konzepten. Dokumentieren Sie hier Ihre bereits umgesetzten Maßnahmen. Die TOMs sind Pflichtbestandteil sowohl Ihrer AVV-Verträge als auch Ihres Verarbeitungsverzeichnisses.',
    ctaLabel: 'TOM anlegen',
    ctaRoute: '/tom/new',
    icon: 'shield',
  },
  processing: {
    number: 4,
    title: 'Verarbeitungsverzeichnis (VVT) aufbauen',
    description: 'Das VVT nach Art. 30 DSGVO ist das Herzstück Ihrer Dokumentationspflicht. Es listet strukturiert auf, welche personenbezogenen Daten Sie zu welchem Zweck verarbeiten — etwa "Lohnabrechnung", "Kundenverwaltung" oder "Bewerbermanagement". Starten Sie mit den offensichtlichen Prozessen; Vollständigkeit entsteht iterativ.',
    ctaLabel: 'Verarbeitung anlegen',
    ctaRoute: '/processing/new',
    icon: 'documents',
    tip: 'Nutzen Sie die mitgelieferten Branchenvorlagen für einen schnellen Einstieg.',
  },
  linking: {
    number: 5,
    title: 'Dienstleister und TOMs verknüpfen',
    description: 'Ein VVT-Eintrag ohne Angabe von Empfängern und Schutzmaßnahmen ist unvollständig. Verbinden Sie jede freigegebene Verarbeitung mit den beteiligten Dienstleistern und den anwendbaren TOMs. So entsteht automatisch ein konsistentes Gesamtbild — und Sie sehen sofort, wenn ein AVV fehlt oder eine Schutzmaßnahme nicht greift.',
    ctaLabel: 'Verarbeitungen verwalten',
    ctaRoute: '/processing',
    icon: 'chain-link',
  },
  privacy_notices: {
    number: 6,
    title: 'Datenschutzhinweise erstellen',
    description: 'Art. 13 und 14 DSGVO verlangen, dass Sie betroffene Personen transparent informieren — auf der Website, im Bewerbungsformular, beim Newsletter. Aus Ihren VVT-Einträgen kann die Software die passenden Hinweise automatisch generieren. Prüfen Sie den Entwurf und geben Sie ihn frei.',
    ctaLabel: 'Datenschutzhinweis erstellen',
    ctaRoute: '/privacy-notices/new',
    icon: 'hint',
  },
  dsr_process: {
    number: 7,
    title: 'Prozess für Betroffenenanfragen kennen',
    description: 'Betroffene haben laut Art. 15–22 DSGVO Rechte auf Auskunft, Berichtigung, Löschung und mehr. Anfragen müssen innerhalb eines Monats beantwortet werden. Machen Sie sich mit dem Modul vertraut, bevor der Ernstfall eintritt — so können Sie im Bedarfsfall fristgerecht reagieren.',
    ctaLabel: 'Modul ansehen',
    ctaRoute: '/data-subject-requests',
    icon: 'person-placeholder',
  },
  breach_process: {
    number: 8,
    title: 'Prozess für Datenschutzvorfälle kennen',
    description: 'Ein Datenschutzvorfall muss laut Art. 33 DSGVO innerhalb von 72 Stunden an die Aufsichtsbehörde gemeldet werden. Die Uhr läuft ab Kenntnisnahme. Schauen Sie sich das Vorfall-Modul an, legen Sie ggf. eine interne Meldekette fest und testen Sie einmal den Ablauf mit einem Beispiel-Eintrag.',
    ctaLabel: 'Modul ansehen',
    ctaRoute: '/breaches',
    icon: 'alert',
  },
  team: {
    number: 9,
    title: 'Team einladen (optional)',
    description: 'Datenschutz ist Teamarbeit. Laden Sie Kolleginnen und Kollegen mit den passenden Rollen ein — z.B. Fachabteilungen für die Erfassung ihrer Verarbeitungen, den DSB für Freigaben. Die Rollenmatrix finden Sie in der Benutzerverwaltung.',
    ctaLabel: 'Benutzer verwalten',
    ctaRoute: '/users',
    icon: 'employee',
  },
};

export const ONBOARDING_STEP_ORDER: OnboardingStepKey[] = [
  'organization', 'service_providers', 'toms', 'processing',
  'linking', 'privacy_notices', 'dsr_process', 'breach_process', 'team'
];
